<template>
  <section class="hello">
    <div class="hero">
      <div class="wrapper">
        <h1 class="intro-title">We make great Magento modules</h1>
        <article class="intro-text">Our focus is on making good quality extensions that are reliable, multi-store compatible, practical and maintain an appropriate level of ease of use. We also strive for our work to be as compatible as possible with Magento and its extended eco-system by limiting the use of preferences and Javascript maps, preferring to use Magento’s built in plugin &amp; mixin systems.</article>
        <a class="cta button" :href="about_href"><span>More about us</span></a>
      </div>
    </div>
    <div class="content">
      <div class="wrapper">
        <h2 class="module-title">Our modules</h2>
        <div class="modules_grid">
          <div id="customer-attributes" class="module">
            <h3>Customer Attributes</h3>
            <p>Our Customer Attribute Extension gives you the opportunity to get more data from your customers in the way they are used to.</p>
            <a class="button right" href="/customer-attributes" title="Customer Attributes"><span>View module</span></a>
          </div>
          <div id="cms-transfer" class="module">
            <h3>CmsTransfer</h3>
            <p>Our CmsTransfer Extension is the essential tool for keeping your CMS Pages, CMS Blocks & Widget Instances up to date between multiple Magento installs.</p>
            <a class="button right" href="/cms-transfer" title="CmsTransfer"><span>View module</span></a>
          </div>
          <div id="elastic-status" class="module">
            <h3>Elastic Status</h3>
            <p>Our Elastic status Extension helps you monitor the status of Elasticsearch, and find out about errors.</p>
            <a class="button right" href="/elastic-status" title="Elastic Status"><span>View module</span></a>
          </div>
          <div id="certified" class="module">
            <h3>Adobe Certified Professional—Adobe Commerce Developer</h3>
            <div class="iframe-wrapper"><div data-iframe-width="250" data-iframe-height="270" data-share-badge-id="01ced7b5-f65f-4ad4-b9e6-8c350732ad8c" data-share-badge-host="https://www.credly.com"></div></div>
            <p>I'm extremely proud to have achieved my Adobe Certified Professional—Adobe Commerce Developer certification.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome!',
      start_para: 'Welcome to Rees Solutions!',
      para: [
        { text: 'Rees Solutions is a creation of Mark Rees a full stack web developer (sometimes referred to as full stack minus the pretty bits) and sole proprietor. Our current focus is on the creation of good quality Magento 2 extensions. Mark believes in making sure that his extensions are reliable, multi-store compatible, practical and maintain an appropriate level of ease of use. Mark also strives for his work to be as compatible as possible with Magento and its extended eco-system by limiting the use of preferences and Javascript maps, preferring to use Magento’s built in plugin & mixin systems.' },
        { text: 'These module follow the Magento coding standard, Open source modules are available from Github via composer as directed in the readme, if you have any questions, issues or enchantment requests they can be done through the repository’s issues section. For extensions that are purchased you can send any issues to the support email address that is available on that marketplace. All current extensions are developed for the 2.4 branch of Magento using PHP7.4. There are no current plans to provide backward compatible versions of these modules.' }
      ],
      most_recent: {
        title: 'Elastic Status',
        link_text: 'here.',
        href: '/elastic-status',
        text: 'Our most recent release is Elastic Status which helps you monitor for Elasticsearch errors, you can find out more including how to get Elastic Status '
      },
      featured: {
        title: 'Customer Attributes',
        link_text: 'here.',
        href: '/customer-attributes',
        text: 'Our upcoming featured extension is Customer Attributes. This extension is being designed to be your solution to your customer & address data needs. You can find out more, including any availability information '
      },
      about_href: '/about'
    }
  },
  created () {
    let doc = document.createElement('script')
    doc.setAttribute('async', true)
    doc.setAttribute('type', 'text/javascript')
    doc.setAttribute('src', '//cdn.credly.com/assets/utilities/embed.js')
    document.head.appendChild(doc)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#certified {
  .iframe-wrapper {
    margin: auto;
    min-height: 270px;
    min-width: 250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue